import type { ProjectPostCreateCommand, ProjectPostCreateResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class CreateProjectPostUseCase {
  constructor(private projectRepository: ProjectRepository) {}

  async execute(command: ProjectPostCreateCommand): Promise<ProjectPostCreateResponse> {
    return this.projectRepository.createProjectPost(command);
  }
}
